export default "__VITE_ASSET__DW6HE_JC__"